<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="card card-default">
                    <div class="card-header">
                        <div class="row pb-2 pt-2">
                            <div class="col-md-2"># конкурса</div>
                            <div class="col-md-3">Заказчик</div>
                            <div class="col-md-2">Сумма конкурса</div>
                            <div class="col-md-2">Срок подачи</div>
                            <div class="col-md-2">Статус</div>
                            <div class="col-md-1">Доп.</div>
                        </div>
                    </div>
                    
                    <div class="card-body">
                        <div class="row pb-2 pt-2 rounded">
                            <div class="col-md-2"># конкурса</div>
                            <div class="col-md-3">Заказчик</div>
                            <div class="col-md-2">Сумма конкурса</div>
                            <div class="col-md-2">Срок подачи</div>
                            <div class="col-md-2">Статус</div>
                            <div class="col-md-1">Доп.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            console.log('Component mounted.')
        }
    }
</script>
